function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export class SessionExposureTrackingProvider {
  constructor(exposureTrackingProvider) {
    _defineProperty(this, "exposureTrackingProvider", void 0);

    _defineProperty(this, "tracked", {});

    this.exposureTrackingProvider = exposureTrackingProvider;
  }

  track(exposure) {
    const trackedExposure = this.tracked[exposure.flag_key];

    if (trackedExposure && trackedExposure.variant === exposure.variant) {
      return;
    } else {
      this.tracked[exposure.flag_key] = exposure;
      this.exposureTrackingProvider.track(exposure);
    }
  }

}
//# sourceMappingURL=sessionExposureTrackingProvider.js.map